import { Component, Input } from '@angular/core';
import { BadgeType } from '@shared/utils/evidence-management';

@Component({
  selector: 'shared-ui-badges-badge',
  templateUrl: './badge.component.html',
  styleUrls: ['./badge.component.css'],
  standalone: false,
})
export class BadgeComponent {
  @Input() type: BadgeType = BadgeType.Default;
  @Input() text = '';

  constructor() {}
}
